import type { SupportedLang } from "@acme/validators";

export const languageDisplayNames: Record<SupportedLang, string> = {
  javascript: "JavaScript",
  typescript: "TypeScript",
  tsx: "TSX",
  css: "CSS",
  html: "HTML",
  java: "Java",
  kotlin: "Kotlin",
  python: "Python",
  rust: "Rust",
  angular: "Angular",
  go: "Go",
  c_sharp: "C#",
  cpp: "C++",
  c: "C",
  php: "PHP",
  ruby: "Ruby",
  elixir: "Elixir",
};

export const languageColors: Record<SupportedLang, string> = {
  javascript: "#f7df1e",
  typescript: "#3178c6",
  tsx: "#3178c6",
  css: "#264de4",
  html: "#e34f26",
  java: "#f89820",
  kotlin: "#f18e33",
  python: "#3776ab",
  rust: "#dc322f",
  angular: "#dd0031",
  go: "#00add8",
  c_sharp: "#178600",
  cpp: "#f34b7d",
  c: "#555555",
  php: "#8993be",
  ruby: "#701516",
  elixir: "#6e4a7e",
};
